import TgAvatar from './TgAvatar';
import { Avatar, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useGetUserDataQuery } from '../store/auth';

const FALLBACK_AVATAR_STYLE: React.CSSProperties = {
    backgroundColor: '#f0f0f0',
    color: '#8c8c8c',
};

const MyTgAvatar = () => {
    const { data, isLoading, error } = useGetUserDataQuery();

    if (isLoading) {
        return <Spin />;
    }

    // Нет данных Telegram — заглушка-человечек
    if (error || !data) {
        return (
            <Avatar
                size="large"
                style={FALLBACK_AVATAR_STYLE}
                icon={<UserOutlined />}
                aria-label="Пользователь"
            />
        );
    }

    return (
        <TgAvatar user={data} size="large" />
    );
};

export default MyTgAvatar;
